"use strict";
/**
* SkypeTokenData.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* Holder for SkypeToken information
*/
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var subscribableevent_1 = require("subscribableevent");
var SyncTasks = require("synctasks");
var SkypeTokenData = /** @class */ (function () {
    function SkypeTokenData() {
        this.skypeTokenChanged = new subscribableevent_1.default();
    }
    SkypeTokenData.prototype.putSkypeTokenData = function (initialData) {
        this._data = initialData;
        if (this.isSkypeTokenValid()) {
            this.skypeTokenChanged.fire();
        }
        if (this.isSkypeTokenValid() && this._validSkypeTokenDeferral) {
            var deferral = this._validSkypeTokenDeferral;
            this._validSkypeTokenDeferral = undefined;
            deferral.resolve(void 0);
        }
    };
    SkypeTokenData.prototype.isSkypeTokenValid = function () {
        var tokenData = this._data;
        return !!tokenData && !!tokenData.skypeToken && tokenData.skypeTokenExpiration > Date.now();
    };
    SkypeTokenData.prototype.getSkypeToken = function () {
        var tokenData = this._data;
        if (!tokenData || !tokenData.skypeToken) {
            throw 'No Skype Token provided';
        }
        return tokenData.skypeToken;
    };
    SkypeTokenData.prototype.getSkypeTokenHash = function (token) {
        if (token === undefined) {
            return 0;
        }
        return _.reduce(token, function (mem, next) { return (mem * 101 + next.charCodeAt(0)) % 999727999; }, token.length);
    };
    SkypeTokenData.prototype.waitForValidSkypeToken = function () {
        if (this.isSkypeTokenValid()) {
            return SyncTasks.Resolved();
        }
        // Need to wait for a new one to be poked in
        if (!this._validSkypeTokenDeferral) {
            this._validSkypeTokenDeferral = SyncTasks.Defer();
        }
        return this._validSkypeTokenDeferral.promise();
    };
    return SkypeTokenData;
}());
exports.default = SkypeTokenData;
